import {Directive, ElementRef, NgZone, OnDestroy, OnInit} from '@angular/core';

/**
 * Fades an element up into place the first time it scrolls into view.
 * The resting state is fully visible: without IntersectionObserver, or for visitors
 * who prefer reduced motion, nothing is hidden (see `.ts-reveal` in _talespinner-public.scss).
 */
@Directive({
  selector: '[tsReveal]',
  host: {class: 'ts-reveal'}
})
export class RevealDirective implements OnInit, OnDestroy {

  private observer?: IntersectionObserver;

  constructor(private element: ElementRef<HTMLElement>, private zone: NgZone) {
  }

  ngOnInit() {
    if (typeof IntersectionObserver === 'undefined'
      || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const element = this.element.nativeElement;
    element.classList.add('is-waiting');

    this.zone.runOutsideAngular(() => {
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          element.classList.remove('is-waiting');
          this.observer?.disconnect();
        }
      }, {rootMargin: '0px 0px -10% 0px'});
      this.observer.observe(element);
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
